<template>
    <!--编辑中心-->
    <div class="main-editor" contenteditable="false">
        <div class="image-wrap"v-if="this.item.image !== 'noUpload' && this.item.image">
            <div v-if="isImage(this.item.image)">
                <div class="main-editor-mask"></div>
                <img :src="this.item.image" width="90%">
                <button style="margin-top:-100px">更换
                    <eber-upload :index="index" @changePic="changePic"></eber-upload>
                </button>
                <button @click="delUpload">删除</button>
            </div>
            <video v-else controls="controls" class="videoshow" width="90%" height="100%">
                <source :src="this.item.image" type="video/mp4">您的浏览器不支持播放视频
            </video>
        </div> 
        <div v-else-if="this.item.image == 'noUpload'" style="text-align:center;">
            <el-progress type="circle" :percentage="newPercentage"></el-progress>
        </div>
        <div class="edit-container con" 
            :id="paragraph(index)" 
            contenteditable="true"
            @click="clickFun"
            @input="inputFun($event)"
            v-html="this.newRemarks"
        >
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
export default {
    name: "EberParagraph",
    props:['index','item','focusIndex','percentage'],
    data(){
        return{
            newRemarks:this.item.remark,
            newPercentage:this.percentage
        }
        
    },
    watch: {
        item:{
            handler(n,o){
                if (_.isEqual(n.remark, this.newRemarks)) {
                    if(n.remark == undefined){
                        document.getElementById('paragraph_'+(this.index)).innerHTML='';
                    }
                    return
                }
                if(this.index !== this.focusIndex){
                    this.newRemarks = n.remark;
                }
            }
        },
        percentage:{
            handler(n,o){
               this.newPercentage = n;
            },
            deep:true,
            immediate:true
        }
    },
    methods: {
        isImage (url) {
            let type = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
            return _.indexOf(['jpg', 'jpeg', 'png', 'bmp'], type) >= 0
        },
        paragraph:function(index){
            return "paragraph_" +index
        },
        clickFun:function(){
           var selArr = [];
           let sel = this.getSelectedNode();
           if(!_.isEmpty(sel)){
                for(var i=0;i<sel.length;i++){
                    if(sel[i] == "B"){
                        selArr.push(1);
                    }else if(sel[i] == "U"){
                        selArr.push(3);
                    }else if(sel[i] == "STRIKE"){
                        selArr.push(4);
                    }else if(sel[i] == "I"){
                        selArr.push(2);
                    }else if(sel[i] == "I"){
                        selArr.push(2);
                    }else if(sel[i] == "UL"){
                        selArr.push(10);
                    }else if(sel[i] == "OL"){
                        selArr.push(9);
                    }else if(sel[i] == "P"){
                        selArr.push(5);
                    }else if(sel[i] == "H5"){
                        selArr.push(6);
                    }else if(sel[i] == "H3"){
                        selArr.push(7);
                    }else if(sel[i] == "H1"){
                        selArr.push(8);
                    }else{
                        selArr.push(-1);
                    }
                }
            }
            this.$emit('toolStyle',selArr);
        },
        getSelectedNode(){
            let sel=[];
            if(document.selection)
                return document.selection.createRange().parentElement(); 
            else {
                var selection = window.getSelection(); 
                if(selection.rangeCount> 0){
                    let _this = selection.getRangeAt(0).startContainer.parentNode;
                    sel.push(_this.tagName);
                    for(var i = 0;i<1000;i++){
                        if(_this.tagName !== 'DIV'){
                            sel.push(_this.tagName);
                            _this = _this.parentNode;
                        }else{
                            return sel;
                        }
                    }
                }
            } 
        },
        //同步左侧列表
        inputFun(e){
            let remark = e.target.innerHTML;
            if(remark == '<br>'){
                this.$emit('toolStyle',[]);
            }
            this.$emit('changeLeft',this.index,remark);
        },
        //修改图片、视频
        changePic(type,file,index){
            this.$emit('uploadFiles',type,file,1,index);
        },
        delUpload(){
            let item = {
                thumbnail: null,
                image: null,
                width: null,
                height: null
            }
            this.$emit('delPic',this.index,item);
        }
    },
    created() {
        this.$nextTick(() =>{
            if(this.focusIndex !== -1){
                document.getElementById('paragraph_'+(this.focusIndex)).focus();
                document.getElementById('paragraph_'+(this.focusIndex)).innerHTML='';
            }
        });
    }
}
</script>

<style>
    .main-editor{
        width: 471px;
        float: right;
    }
    .edit-container{
        width: 100%;
        min-height: 50px;
        border: none;
        margin: 5px auto 0;
        font-size: 17px;
        font-family: 微软雅黑;
        line-height: 30px;
    }
    .con:empty:before{ 
        content: '点击添加文字'; 
        color: #9daab6; 
    }
    [contenteditable]:focus{
        outline: none;
    }
    .main-editor-mask{
        display: none;
        position:absolute;
        width: 90%;
        height: 100%;
        z-index: 9;
        background: #000;
        opacity: 0.3;
        left: 0;
        top: 0;
    }
</style>
<style scoped>
    h1{
        font-size: 20px;
    }
    h3{
        font-size: 17px;
    }
    h5{
        font-size: 15px;
    }
    .image-wrap{
        position: relative;
    }
    .image-wrap:hover .main-editor-mask,.image-wrap:hover button{
        display: block;
    }
    .image-wrap button{
        display: none;
        position: absolute;
        background: #fff;
        top:50%;
        left: 50%;
        z-index: 99;
        border: none;
        width: 100px;
        height: 40px;
        margin-left: -70px;
        border-radius: 30px;
    }
</style>